import { render } from "./Dashboard.vue?vue&type=template&id=d1f035d6"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script